export default __webpack_public_path__ + "static/media/Asset 1.f182417f.svg";